// AI Management Permissions

export const AI_PROMPT_HANDLE = 176;
export const AI_MESSAGES_LIST = 177;
